export const noteIconsMap: Readonly<{ [key: string]: string }> = {
  success: 'checkmark-circle-2-outline',
  warning: 'alert_circle_outlined',
  danger: 'close_circle_outlined',
  info: 'info-outline',
};
